import { RUTAS } from '@/common/components/user-menu/constants/user-profile-content'
import { resolveLegacyMenuUrl } from './legacy-menu-url.js'

/**
 * Destino del ítem "Administración de usuarios" del menú de usuario.
 *
 * El microfrontend de administración de usuarios todavía no está habilitado en todos los
 * ambientes. Mientras un ambiente siga usando la pantalla del PHP legacy, define
 * `VITE_LEGACY_ADMIN_USUARIO_URL` con esa URL (build-time) y el ítem navega ahí; si la
 * variable no está definida se navega a la ruta interna del shell que monta el
 * microfrontend (comportamiento de test/develop/prod).
 *
 * @returns {string} URL (absoluta para el PHP legacy, o ruta interna del shell)
 */
export function resolveAdminUsuariosUrl() {
  return resolveLegacyMenuUrl(import.meta.env.VITE_LEGACY_ADMIN_USUARIO_URL, RUTAS.adminUsuarios)
}
